import React from 'react';

import { headerText, listContent, warningText } from '@app/components/Pages/Covid19/Covid19Content';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';

const Covid19 = () => {
	return (
		<HelmetProvider>
			<div>
				<Masthead title="Covid-19 Update" imageSrc={require('@app/content/covid-protocol.jpg')} imageAlt="Dr. Dani helps sick dog" />
				<RichText title="" text={headerText} />

				<VideoEmbed text={warningText} />

				<RichText title="We will also be taking the following precautions to ensure both you and our team remains safe:" text={listContent} />
			</div>
		</HelmetProvider>
	);
};

export default Covid19;
